export default __webpack_public_path__ + "images/Asteroid.2-157419e7fdd986e1a9cfa9563a3e7e48.png";